import type * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';

const validateSignature = (value: unknown, isRequired: boolean): true | 'Signature and date are required' => {
  if (!value || typeof value !== 'object') {
    return isRequired ? 'Signature and date are required' : true;
  }

  const signatureValue = value as QuestionnaireApiModels.SignatureFieldValue;
  const hasText = Boolean(signatureValue.text && signatureValue.text.trim().length > 0);
  const hasDate = Boolean(signatureValue.date);

  if (!isRequired && !hasText && !hasDate) {
    return true;
  }

  return hasText && hasDate ? true : 'Signature and date are required';
};

export default validateSignature;
